import React from 'react';
import { useTranslationText } from 'locale';
import { HorizontalView, VerticalView } from 'vendor-deprecated/Wrapper';
import { IUser } from 'types/types';
import { AppColors } from 'helpers';
import { TextDisplay } from 'vendor-deprecated/Text';
import { Button } from 'vendor-deprecated/Button';
import { AnimationView } from 'vendor-deprecated/Animation';
import { TextAreaInput } from 'vendor-deprecated/TextAreaInput';
import { RateBar } from 'vendor-deprecated/Rate/index';

type ReviewBarProps = {
  rate?: number | null;
  content?: string | null;
  isEdit?: boolean;
  actionTitle?: string;
  auth?: IUser;
  onEditReview?: (rate: number, content: string) => void;
  onCreateReview?: (rate: number, content: string) => void;
};

export const WriteReviewBar = (props: ReviewBarProps) => {
  const { translation } = useTranslationText();
  const [rateValue, setRateValue] = React.useState(props.rate || 0);
  const [reviewContent, setReviewContent] = React.useState(props.content || '');

  return (
    <VerticalView fullWidth alignContent={'centerLeft'}>
      <AnimationView width={'100%'} animation={'fadeIn'}>
        <VerticalView
          fullWidth
          alignContent={'centerLeft'}
          padding={'15px'}
          borderRadius={'4px'}
          background={AppColors.WHITE}
          marginTop={'15px'}
          border={`1px solid ${AppColors.BORDER}`}
        >
          <VerticalView alignContent={'centerLeft'}>
            <TextDisplay size={'15px'} color={AppColors.BLACK} fontWeight={'bold'} marginRight={'20px'}>
              {translation('reviewRate')}
            </TextDisplay>
            <RateBar value={rateValue} onChange={(value) => setRateValue(value)} />
            {/* <RateView star={rateValue} editable onChange={(value) => setRateValue(value)} /> */}
          </VerticalView>

          <HorizontalView fullWidth paddingTop={'5px'} position={'relative'}>
            <TextAreaInput
              text={translation('reviewText')}
              width={'100%'}
              height={'100px'}
              value={reviewContent}
              onChange={(e) => {
                if (e.target.value.length <= 300) {
                  setReviewContent(e.target.value);
                }
              }}
            />
            <HorizontalView position={'absolute'} top={'2px'} right={'10px'}>
              <TextDisplay size={'12px'} color={AppColors.BLACK} fontWeight={'bold'}>
                {reviewContent.length}/300
              </TextDisplay>
            </HorizontalView>
          </HorizontalView>
          <HorizontalView fullWidth alignContent={'centerRight'} paddingTop={'10px'}>
            <Button
              disabled={rateValue === 0 || reviewContent.replace(/ /g, '').length === 0}
              fontSize={'15px'}
              minWidth={'40px'}
              height={'40px'}
              text={translation(props.isEdit ? 'editReview' : 'submitReview')}
              fontWeight={'normal'}
              color={AppColors.WHITE}
              backgroundColor={AppColors.HEADER}
              borderRadius={'5px'}
              onClick={async () => {
                if (props.isEdit && props.onEditReview) {
                  props.onEditReview(rateValue, reviewContent);
                } else {
                  props.onCreateReview && props.onCreateReview(rateValue, reviewContent);
                }
                // if (!props.courseId) {
                //   return;
                // }
                // await createReviewApi.createReview({
                //   courseId: props.courseId,
                //   rate: rateValue,
                //   content: reviewContent,
                // });

                // setRateValue(0);
                // setReviewContent('');
              }}
            />
          </HorizontalView>
        </VerticalView>
      </AnimationView>
    </VerticalView>
  );
};
